export { default as EN } from "./en.json";
export const NAMESPACE = "demonstrator";
